import { CurrentUser } from '@/types/me';
import { useStepperContext } from '@/components-new/stepper.hooks';
import { useForm } from 'react-hook-form';
import { useUpdateUserSettings } from '@/features/user-settings/api/api';
import React from 'react';
import { Heading } from 'grommet';
import { Text } from '@/components-new/text';
import { UserAddressField, UserSettingsAddressForm } from '@/features/user-settings/components/user-address-field';

export const AddressStep = ({ user }: { user: CurrentUser }) => {
  const { onNextStep } = useStepperContext();

  const {
    mutateAsync: updateUserSettings
  } = useUpdateUserSettings();

  const {
    control,
    setValue,
    getValues,
    formState: { isValid },
  } = useForm<UserSettingsAddressForm>({
    mode: "onChange",
  });

  onNextStep(async () => {
    if (!isValid) return false;

    try {
      await updateUserSettings({
        zipCode: getValues('zipCode'),
        stateId: getValues('stateId'),
        city: getValues('city'),
      });
    } catch(error) {
      return false;
    }

    return true;
  });

  return (
    <>
      <Heading>Address</Heading>
      <Text>
        Please enter the zip code of where you primarily work from. If you work from multiple locations, use the location where you work most frequently.
      </Text>
      <UserAddressField
        zipCode={user.zipCode}
        city={user.city}
        stateId={user.stateId}
        setValue={setValue}
        control={control}
      />
    </>
  );
}
